import { Mapper } from "../../../../base/utils/mapper";
import { DominantEyeModel } from "../../../../domain/models/consult/dominant-eye.model";
import { DominantEyeEntity } from "../entities/dominant-eye.entity";


export class DominantEyeImplementationRepositoryMapper extends Mapper<DominantEyeEntity, DominantEyeModel> {
    mapFrom(param: DominantEyeEntity): DominantEyeModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DominantEyeModel): DominantEyeEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}